import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["fill"]
const _hoisted_10 = ["fill"]
const _hoisted_11 = ["stroke"]


export default /*@__PURE__*/_defineComponent({
  __name: 'trainSvgIcon',
  props: {
    color: {},
    width: {},
    height: {},
    fill: {},
    stroke: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: _ctx.width,
    height: _ctx.height,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M5.28809 14.35H15.4363V14.3942C15.4363 15.3086 14.6946 16.0503 13.7802 16.0503H6.94417C6.02975 16.0503 5.28809 15.3086 5.28809 14.3942V14.35Z",
      fill: _ctx.fill
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M6.96318 15.7891L4.16797 19",
      stroke: _ctx.stroke,
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round"
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M13.7603 15.7891L16.5555 19",
      stroke: _ctx.stroke,
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round"
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M5.03467 17.7284H15.6894",
      stroke: _ctx.stroke,
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M7.94536 2.43915H12.798C14.1203 2.43915 15.2477 3.48345 15.4633 4.90704L16.6856 11.4028C16.957 13.1991 15.688 14.8305 14.0203 14.8305H6.70232C5.03065 14.8305 3.76034 13.1913 4.0383 11.3924L5.28134 4.89794C5.50085 3.47826 6.62698 2.43915 7.94536 2.43915V2.43915Z",
      stroke: _ctx.stroke,
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_6),
    _createElementVNode("path", {
      d: "M13.2422 2.70026L7.48032 2.70026V2.65609C7.48032 1.74168 8.22199 1.00001 9.1364 1.00001L11.5861 1.00001C12.5005 1.00001 13.2422 1.74168 13.2422 2.65609V2.70026V2.70026Z",
      fill: _ctx.fill
    }, null, 8, _hoisted_7),
    _createElementVNode("path", {
      d: "M7.23102 13.0862C7.83862 13.0862 8.33118 12.5936 8.33118 11.986C8.33118 11.3784 7.83862 10.8859 7.23102 10.8859C6.62342 10.8859 6.13086 11.3784 6.13086 11.986C6.13086 12.5936 6.62342 13.0862 7.23102 13.0862Z",
      fill: _ctx.fill
    }, null, 8, _hoisted_8),
    _createElementVNode("path", {
      d: "M13.5113 13.0862C14.1189 13.0862 14.6114 12.5936 14.6114 11.986C14.6114 11.3784 14.1189 10.8859 13.5113 10.8859C12.9037 10.8859 12.4111 11.3784 12.4111 11.986C12.4111 12.5936 12.9037 13.0862 13.5113 13.0862Z",
      fill: _ctx.fill
    }, null, 8, _hoisted_9),
    _createElementVNode("path", {
      d: "M4.45654 9.53764H16.2686L15.7075 4.74994H5.37486L4.45654 9.53764Z",
      fill: _ctx.fill
    }, null, 8, _hoisted_10),
    _createElementVNode("path", {
      d: "M10.3623 4.43817V9.53761",
      stroke: _ctx.stroke,
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_11)
  ], 8, _hoisted_1))
}
}

})